<template>
  <v-text-field
    v-model="valor"
    ref="input"
    type="tel"
    class="direita"
    @focus="onFocus"
    @blur="onBlur"
    @input="onInput"
    @keypress="onKeypress"
  >
  </v-text-field>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: 0,
  },
  decimais: {
    type: [String, Number],
    default: 2,
  },
  select: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const valor = ref('0,00');
const internalChange = ref(false);
const isFocused = ref(false);

function onInput(event) {
  internalChange.value = true;
  if (event.target.value === "") {
    valor.value = 0;
    selectInput(event.target);
  }

  let valor_us = valorUS(valor.value);
  valor_us = trunc(valor_us, props.decimais);
  emit('update:modelValue', valor_us);
}


function onKeypress(event) {
  if (event.key === '.') {
    event.preventDefault(); // Previne a ação padrão de inserir o ponto
    if (!event.target.value.includes(',')) { // Só adiciona vírgula se não houver nenhuma
      const cursorPosition = event.target.selectionStart;
      const originalValue = event.target.value;
      event.target.value = originalValue.slice(0, cursorPosition) + ',' + originalValue.slice(cursorPosition);
      event.target.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
    }
  } else {
    onlynumbers(event);
  }
}


function onBlur() {
  internalChange.value = false;
  isFocused.value = false;

  valor.value = valorBR(props.modelValue, props.decimais);
}

function onFocus(event) {
  isFocused.value = true;
  if (props.select) {
    selectInput(event.target);
  }
}
function onlynumbers(event) {
  const key = String.fromCharCode(event.keyCode || event.which);
  const alreadyHasComma = event.target.value.includes(',');

  // Permite apenas números, uma única vírgula
  if (!/^[0-9]+$/.test(key) && (key !== ',' || alreadyHasComma)) {
    event.preventDefault();
  }
}


function selectInput(target) {
  setTimeout(() => {
    target.select();
  }, 0);
}

function valorUS(valor) {
  if (valor) {
    // eduardo let valor_us = valor.replace(/\./g, "").replace(/\,/g, ".");
    let valor_us = valor.replace(/\./g, "").replace(/,/g, ".");

    return Number(valor_us);
  }

  return 0;
}

function valorBR(valor, decimais = 2) {
  if (valor) {
    return valor.toLocaleString('pt-BR', { minimumFractionDigits: decimais, maximumFractionDigits: decimais } )
  }

  return (0).toLocaleString('pt-BR', { minimumFractionDigits: decimais, maximumFractionDigits: decimais } );
}

function trunc(valor, decimais = 2) {
  let dec = Math.pow(10, decimais);
  return Number((parseInt(valor * dec) / dec).toFixed(decimais));
}

watch(() => props.modelValue, (value) => {
  if (!internalChange.value) {
    valor.value = valorBR(value, props.decimais);
  }
  }, { immediate: true }
);

</script>

<style scoped>
.direita.v-input :deep(input) {
  text-align: right !important;
}

.transparente :deep(.v-input__slot) {
  background: none;
}
</style>
